<template>
  <div id="notFound" class="d-flex h-100 align-items-center">
    <b-container>
      <div class="text-center mb-5">
        <b-row>
          <b-col class="ambiance">
            <b-img src="@/assets/svg/404.svg" alt="Not Found" />
          </b-col>

          <b-col class="d-flex align-self-stretch align-items-center">
            <div class="text-left">
              <h1 class="upper bold display-1">Page non trouvée</h1>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
    
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
#notFound {

}
</style>
